<template>
    <van-popup  teleport=".wrapper" v-model="show"   :overlay-style="{  backdropFilter: 'blur(10px)'}">
        <!-- <div class="bailu">
        </div> -->
        <div class="content" @click="sharePop">
            
            <div class="bottom" v-show="!share">
                <div class="text">{{ text }}</div>
                <div class="line"></div>
                <div class="share-bt2"></div>
            </div>
            
            <div class="sharePlacards" id="map">
                <div class="logo"></div>
                <div class="title"></div>
                <div class="callingCardBox">
                    <div class="text">#2024年接好运#</div>
                    <div class="box">
                        <div class="left">
                            <div class="information">
                                <div class="nameText">姓名/name</div>
                                <div class="name">{{ dataModel.name }}</div>
                                <div class="timeText" v-show="time">注册时间/time</div>
                                <div class="name" v-show="time" style="top:0">{{ time }}</div>
                                <div class=""></div>
                            </div>
                            <div class="labels">
                                <div class="labelsText" :class="dataModel.manualTag.length==5?'center':''">{{ dataModel.manualTag }}</div>
                                <div class="proportion">全城仅有{{dataModel.percent}}%用户获得</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="rightText">{{ rightText }}</div>
                            <div class="imgBox" v-if="imgModel.url">
                                <img :src="imgModel.url" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="signature">{{ dataModel.goldenSentence }}</div>
                    <div class="bottomConetent">
                        <div class="code">
                            <VueQr class="codeImg" draggable="false" :correctLevel="3" :dotScale="1" :margin="0" :size="370"
                            :text="codeUrl" />
                        </div>
                        <div class="tips">{{ tips }}</div>
                        <div class="tag"> Wandering Adventures</div>
                    </div>
                </div>
                <div class="tags"></div>
            </div>
            <div class="shareBox" v-show="share">
               
                <div class="title"></div>
                <div class="callingCardBox">
                    <div class="text">#2024年接好运#</div>
                    <div class="box">
                        <div class="left">
                            <div class="information">
                                <div class="nameText">姓名/name</div>
                                <div class="name">{{ dataModel.name }}</div>
                                <div class="timeText" v-show="time">注册时间/time</div>
                                <div class="name" v-show="time" style="top:0">{{ time }}</div>
                                <div class=""></div>
                            </div>
                            <div class="labels">
                                <div class="labelsText" :class="dataModel.manualTag.length==5?'center':''">{{ dataModel.manualTag }}</div>
                                <div class="proportion">全城仅有{{dataModel.percent}}%用户获得</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="rightText">{{ rightText }}</div>
                            <div class="imgBox" v-if="imgModel.url">
                                <img :src="imgModel.url" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="signature">{{ dataModel.goldenSentence }}</div>
                    <div class="bottomConetent">
                        <div class="code">
                            <VueQr class="codeImg" draggable="false" :correctLevel="3" :dotScale="1" :margin="0" :size="370"
                            :text="codeUrl" />
                        </div>
                        <div class="tips">{{ tips }}</div>
                        <div class="tag"> Wandering Adventures</div>
                    </div>
                </div>

            </div>
            <div class="bottomBox" v-show="share">
                <div class="cancel"  v-show="share" @click.stop="cancel"></div>
                <div class="leftBox" @click.stop="download">
                    <div class="download"></div>
                    <div class="iconTetx">
                        保存海报
                    </div>
                </div>
                <div class="leftBox" @click.stop="shareOpen">
                    <div class="weixin"></div>
                    <div class="iconTetx">
                        分享链接
                    </div>
                </div>
            </div>
            <img v-show="pic" class="poster" :src="pic" alt="">
            <guide ref="guide" />
        </div>
    </van-popup>
</template>
 
<script>
import {editShare} from '@/api'
import html2canvas from 'html2canvas'
import VueQr from "vue-qr";
import guide from './guide.vue'
import { ixmShare,ixmSaveImage } from '@/assets/js/sdkTest'
// import CityBridge from '@/assets/js/js-bridge.js'
export default {
    components: {
        VueQr,
        guide
    },
    props: ['dataModel','time','imgModel','codeUrl'],
    data() {
        return {
            form: {
                appId: '5e2475cf8cbc435',
                nonceStr: '',
                timestamp: '',
                signature: '',
                jsApiList: 'share'
            },
            applicationType:'',
            pic:'',
            show: false,
            share:false,
            text:'您还未分享哦！\n点击立即分享赢周年限定礼！',
            text2:'稳重\n肖年家',
            rightText:'i厦门2023年度报告\n/年度形象',
            tips:'扫码查看\n2023鹭岛数字生活报告\n邀您一起领好礼'
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$toast.loading({
                    message: '生成海报中',
                    forbidClick: true,
                    duration: 0,
                })
                this.$nextTick(() => {
                    setTimeout(()=>{
                        this.$toast.clear()
                        this.createImage()
                    },1000)
                    
                })
            }
        }
    },
    computed: {},
    methods: {
        cancel(){
            console.log('111')
            this.show = false

        },
        // handleInit () {
        //     SCWJSBridge.config(
        //         {
        //         debug: false,
        //         ...this.form
        //         },
        //         () => {
        //         return new Promise((resolve) => {
        //             // 当通过缓存验证签名失败时将会调用该方法，重新验证配置信息的有效性。
        //             // TODO:请求服务，返回最新的签名&秘钥
        //             resolve({
        //             ...this.form
        //             })
        //         })
        //         }
        //     )
        // },
        sharePop(){
            console.log('触发')
            if(!this.share){
                if(this.dataModel.isShare == 0){
                    editShare().then(res=>{
                        this.share = true
                        this.$emit('details')
                    })

                }else{
                    this.share = true
                }

            }
        },
        createImage() {
            const domObj = document.getElementById('map')
            console.log(domObj)
            let that = this
            html2canvas(domObj, {
                allowTaint: false,
                useCORS: true,//允许加载跨域的图片
                tainttest: true, //检测每张图片都已经加载完成
                logging: false, //日志开关，发布的时候记得改成false
                onclone(doc) {
                    let e = domObj
                    e.style.display = 'block'
                }
            }).then(function (canvas) {
                // 在微信里,可长按保存或转发
                console.log('生成');
                that.$toast.clear()
                that.pic = canvas.toDataURL('image/png')
                // console.log(that.pic)
                // ImagePreview([that.pic]);
                // that.userGenieshare()

            })
        },
        download(){
            let length = this.pic.length - this.pic.indexOf(',') - 1
            
            if(this.applicationType == 1){
                ixmSaveImage(this.pic.substr(-length))
                setTimeout(()=>{
                    this.$toast('保存成功')

                },1000)

            }else{
                this.$toast('请长按保存图片')

            }
            // if(this.applicationType == 4){
                
            // }else if(this.applicationType!=1){
                // var image = new Image();
                // image.setAttribute("crossOrigin", "anonymous");
                // image.onload = function () {
                //     var canvas = document.createElement("canvas");
                //     canvas.width = image.width;
                //     canvas.height = image.height;
                //     var context = canvas.getContext("2d");
                //     context.drawImage(image, 0, 0, image.width, image.height);
                //     var url = canvas.toDataURL("image/png");

                //     var a = document.createElement("a");
                //     var event = new MouseEvent("click");
                //     a.download = name || "photo";
                //     a.href = url;
                //     a.dispatchEvent(event);
                // };
                // image.src = this.pic;
            // }
        },
        shareOpen(){
            console.log(this.applicationType,'渠道+++++++++++++++++++')
            if(this.applicationType == 4){
                // this.$toast('请长按保存图片')
                this.$refs.guide.show = true
            }else if(this.applicationType == 1 || this.applicationType == 2 ){
                //i厦门app
                if(this.applicationType == 1){
                    //i厦门需要连续点击两次才能调取api
                    ixmShare({
                        title: 'i厦门五周年 赢周年限定礼',
                        desc: '点击查看2023数字生活报告',
                        link: location.origin + location.pathname + "#/loading?channel=fx",
                        imgUrl:'https://ddzyoss.fansiji.com/jqubz/img/20231205/20231205114134076-9975.png'
                    })


                }else if(this.applicationType == 2){

                    this.$ixmShare({
                        title: 'i厦门五周年 赢周年限定礼',
                        desc: '点击查看2023数字生活报告',
                        link: location.origin + location.pathname + "#/loading?channel=fx",
                        imgUrl: 'https://ddzyoss.fansiji.com/jqubz/img/20231205/20231205114134076-9975.png'
                    })
                }
                console.log('准备分享')



            }
        }
    },
    created() {
        console.log('下载')
        this.applicationType = ''  //渠道：1->APP；2->市民卡；3->PC；4->公众号
        let ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.applicationType = 4
        }else if (ua.match(/xmsmk/i) == "xmsmk") {
            this.applicationType = 2
            // return this.smkAuthorize()
        }else {
            this.applicationType = 1
        } 
        // this.handleInit()
    },
    mounted() {
        
    },
};
</script>
<style scoped lang="scss">
.center{
    text-align: center;
}
.cancel {
    width: .24rem;
    height: .24rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/cancel2.png);
    position: absolute;
    top: .2rem;
    right: .2rem;
    z-index: 100;
}
.van-popup {
    /* width: 100% !important;
    height: 100vh !important;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: 6.1rem; */
    background-color: transparent;
    position: fixed;
    z-index: 501;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    // backdrop-filter: blur(5px);
}
.title{
    width: 6.21rem;
    height: .63rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/logoTitle.png);
    // line-height: .67rem;
    // text-align: center;
    // color: #fff;
    // font-family: DingTalkJinBuTi;
    font-size: .54rem;
    margin-top: .5rem
}
.logo{
    width: 2.09rem;
    height: .75rem;
    background-size: 100% auto;
    background-image: url(~@/assets/images/logo.png);
    margin-top: .74rem;
}
.bottomBox{
    width: 7.5rem;
    height: 2.03rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    position: absolute;
    z-index: 500;
    bottom: 0;
    .leftBox{
        width: 50%;
        height: 2.03rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .weixin{
            width: .68rem;
            height: .64rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/weixin.png);
        }
        .download{
            width: .68rem;
            height: .64rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/download.png);
        }
        .iconTetx{
            width: 100%;
            height: .49rem;
            font-size: .35rem;
            color: #7E7E7E;
            margin-top: .23rem;
            text-align: center;
        }
    }
}
.poster{
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    position: fixed;

    top: 0;
    left: 0;
    opacity: 0;
    z-index: 400;
    user-select: auto;
    
    pointer-events: none;
    pointer-events: all;
}
.sharePlacards{
    width: 100vw;
    height: 16.08rem;
    background-size: 100% auto;
    background-image: url(~@/assets/images/imageCustomizationBg.png);
    background-position: top;
    background-repeat: no-repeat;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    position: absolute;
    left: 200vw;

    top: 0;
    z-index: 50;
    .tags{
        width: 4.92rem;
        height: .69rem;
        background-size: 100% auto;
        background-image: url(~@/assets/images/tag.png);
        margin-top: .5rem;
    }
    .title{
        width: 6.21rem;
        height: .63rem;
        background-size: 100% auto;
        background-image: url(~@/assets/images/logoTitle.png);
        // line-height: .67rem;
        // text-align: center;
        // color: #fff;
        // font-family: DingTalkJinBuTi;
        font-size: .54rem;
        margin-top: .68rem;
    }

}
.callingCardBox{
    width: 7.7rem;
    height: 10.15rem;
    background-size: 100% auto;
    background-image: url(~@/assets/images/shareCallingCardBox.png);
    margin-top: .53rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
        position: absolute;
        width: 6.2rem;
        height: .32rem;
        line-height: .32rem;
        text-align: right;
        font-size: .32rem;
        color: #fff;
        font-family: DingTalkJinBuTi;
        top: .3rem;

    }
    .bottomConetent{
        width: 6.27rem;
        height: 1.79rem;
        margin-top: .05rem;
        display: flex;
        .tag{
            min-width: .96rem;
            font-size: .18rem;
            color: #80C7FD;
            margin-left: .7rem;
        }
        .tips{
            min-width: 2.6rem;
            font-size: .24rem;
            color: #194769;
            white-space: pre-line;
            text-align: left;
            margin-top: .7rem;
            margin-left: .23rem;
        }
        .code{
            min-width: 1.79rem;
            height: 1.79rem;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;

            .codeImg{
                width: 1.59rem;
                height: 1.59rem;
            }
        }
        
    }
    .signature{
        width: 6.27rem;
        height: .63rem;
        line-height: .63rem;
        color: #194769;
        font-size: .28rem;
        border-bottom: .02rem solid #A9D9FD;
    }
    .box{
        width: 6.26rem;
        height: 5.77rem;
        border-bottom: .02rem solid #A9D9FD;
        display: flex;
        margin-top: 1.1rem;
    }
    .right{
        width: 3.12rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .re{
            width: 1.42rem;
            height: .37rem;
            border-radius: .2rem;
            background-color: rgba(0,0,0,.7);
            position: absolute;
            bottom: .1rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .refresh{
                width: .33rem;
                height: .33rem;
                background-size: 100% auto;
                background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/refresh.png);
            }
            .reText{
                height: .33rem;
                line-height: .33rem;
                font-size: .21rem;
                margin-left: .04rem;
                color: #fff;
                font-family: SourceHanSansCNMedium;
            }
        }
        .rightText{
            width: 100%;
            text-align: right;
            white-space: pre-line;
            font-size: .21rem;
            font-family: SourceHanSansCNMedium;
        }
        .imgBox{
            width: 100%;
            height: 4.7rem;
            margin-top: .2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: auto;
                max-height: 100%;
            }
        }
    }
    .left{
        width: 3.14rem;
        height: 5.77rem;
        border-right: .02rem solid #A9D9FD;
        .labels{
            width: 100%;
            height: 3.94rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .labelsText{
                width: 100%;
                font-size: .71rem;
                color: #264666;
                font-family: DingTalkJinBuTi;
                white-space: pre-line;

            }
            .proportion{
                width: 3.01rem;
                height: .51rem;
                line-height: .51rem;
                border-radius: .3rem;
                background-color: #80c7fd;
                font-size: .28rem;
                text-align: center;
                color: #fff;
                font-family: DingTalkJinBuTi;
                margin-top: .21rem;
            }
        }
        .information{
            width: 3.14rem;
            height: 1.82rem;
            border-bottom: .02rem solid #A9D9FD;
            box-sizing: border-box;
            .nameText{
                width: 100%;
                height: .33rem;
                line-height: .33rem;
                font-size: .28rem;
                color: #85B4EA;
                font-family: DingTalkJinBuTi;
                // margin-top: -.2rem;
                position: relative;
                top: -.2rem;
            }
            .name{
                width: 100%;
                height: .49rem;
                line-height: .49rem;
                font-size: .35rem;
                color: #194769;
                font-family: SourceHanSansCNMedium;
                position: relative;
                top: -.2rem;
            }
            .timeText{
                width: 100%;
                height: .33rem;
                line-height: .33rem;
                font-size: .28rem;
                color: #85B4EA;
                font-family: DingTalkJinBuTi;
                margin-top: .01rem;
                
            }
        }
    }

}
.content{
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    .shareBox{
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        z-index: 10;
        top: 0;
    }
    .bottom{
        position: absolute;
        bottom: .3rem;
        .text{
            width: 100%;
            text-align: center;
            white-space: pre-line;
            color: #fff;
        }
        .line{
            width: .59rem;
            height: 1.16rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/line.png);
            margin-top: .2rem;
            margin-left: 3rem;
        }
        .share-bt2{
            width: 4.12rem;
            height: 1.4rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/share-bt2.png);
            margin-top: .2rem;
        }
    }
}


/* .bailu{
    width: 5.09rem;
    height: 4.99rem;
    background-image: url(../../assets/images/tipsPop.png);
    background-size: 100% auto;
    background-position: bottom;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    position: relative;
} */
</style>